import { render, staticRenderFns } from "./TeacherEduRecord.vue?vue&type=template&id=0e07e19a&scoped=true&"
import script from "./TeacherEduRecord.vue?vue&type=script&lang=js&"
export * from "./TeacherEduRecord.vue?vue&type=script&lang=js&"
import style0 from "./TeacherEduRecord.vue?vue&type=style&index=0&id=0e07e19a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e07e19a",
  null
  
)

export default component.exports